import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StreamState } from 'src/app/shared/interfaces/stream-state';
import { AudioService } from 'src/app/shared/services/audio.service';

declare const audiojs: any;

@Component({
  selector: 'app-audio-preview',
  templateUrl: './audio-preview.component.html',
  styleUrls: ['./audio-preview.component.scss']
})
export class AudioPreviewComponent implements OnInit, OnDestroy {

  @Input() public url;
  @Input() public thumbnail;
  @Input() public isAdvertisement;
  @Input() public materialAd;
  @Input() public content;
  @Input() public contentType;
  @Output() closeAd = new EventEmitter();
  // public streamUrl: String = 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3';
  seekbarTracker: any = {
    duration: 0,
    time: 0,
    seekPercent: 0,
    hasDVR: false,
  };
  seekTime: number;
  playButtonDisplay: string = 'initial';
  pauseButtonDisplay: string = 'none';
  playCount = 0;
  backupThumb;
  showAd = false;
  // // video asset url
  // @Input() url: any;

  // declare player var
  private player: any;
  state: StreamState;
  currentFile: any = {};
  playlist = [];
  audioSubscriber;
  // constructor initializes our declared vars
  constructor(
    private activeModal: NgbActiveModal,
    private audioService: AudioService,
  ) {
    
    // this.isAdvertisement = true;
    // this.url = false;
    this.player = false;
    this.audioSubscriber =this.audioService.getState()
      .subscribe(state => {
        this.state = state;
        if(this.isAdvertisement && this.contentType!='audio' && this.state.duration !== undefined && this.state.duration <= this.state.currentTime && !this.state.playing){
          this.changeThumbnail();
          this.showAd = true;
          // this.ngOnDestroy();
          this.stop();
          this.closeAd.emit(true);
        }
        if (this.playCount!=1 && this.state.duration !== undefined && this.state.duration <= this.state.currentTime && !this.state.playing && this.isAdvertisement) {
          this.playCount = 1;
          if(this.isAdvertisement && this.contentType=='audio'){
            this.changeThumbnail();
          }
          this.next();
        }
      });
  }

  ngOnInit() {
    if (this.url) {
      if(this.isAdvertisement && this.materialAd.label == 'audio'){
        this.playlist[0] = {
          isAd : true,
          url : this.materialAd.image
        };
        this.playlist[1] = {
          isAd : false,
          url : this.url
        };
      }else if((this.isAdvertisement && this.materialAd.label == 'audio' && this.contentType != 'audio')){
        this.playlist[0] = {
          isAd : true,
          url : this.materialAd.image
        };
        // else if((this.isAdvertisement && this.materialAd.label != 'audio') || (this.isAdvertisement && this.materialAd.label == 'audio' && this.contentType != 'audio')){
        //   this.playlist[0] = {
        //     isAd : true,
        //     url : this.materialAd.image
        //   };
      }
      else{
        this.isAdvertisement=false;
        this.playlist[0] = {
          isAd : false,
          url : this.url
        };
      }
      // https://www.kozco.com/tech/piano2-CoolEdit.mp3
    }


    if (this.thumbnail) {
      this.thumbnail = this.thumbnail;
      this.backupThumb = this.thumbnail;
    }
    else {
      this.thumbnail = '/assets/images/icons/audio-primary-default-icon.jpg';
    }
    if(this.isAdvertisement && this.materialAd.label == 'audio'){
      this.thumbnail = '/assets/images/icons/audio-primary-default-icon.jpg';
    }
    if (this.playlist && this.playlist[0]) {
      this.openFile(this.playlist[0], 0);
    }
  }

  changeThumbnail(){
    if (this.backupThumb) {
      this.thumbnail = this.backupThumb;
    }
  }

  playStream(url) {
    this.audioService.playStream(url)
      .subscribe(events => {
        // listening for fun here
      });
  }

  openFile(file, index) {
    this.currentFile = { index, file };
    
    this.audioService.stop();
    this.playStream(file.url);
  }

  pause() {
    this.audioService.pause();
  }

  play() {
    this.audioService.play();
  }

  stop() {
    this.audioService.stop();
  }

  next() {

    const index = this.currentFile.index + 1;
    const file = this.playlist[index];
    if (file != undefined) {
      this.openFile(file, index);
    } else {
      this.openFile(this.playlist[0], 0);
    }

  }

  previous() {
    const index = this.currentFile.index - 1;
    const file = this.playlist[index];
    if (file != undefined) {
      this.openFile(file, index);
    } else {
      this.openFile(this.playlist[this.playlist.length - 1], this.playlist.length - 1);
    }
  }

  isFirstPlaying() {
    return this.currentFile.index === 0;
  }

  isLastPlaying() {
    return this.currentFile.index === this.playlist.length - 1;
  }

  onSliderChangeEnd(change) {
    this.audioService.seekTo(change.value);
  }

  ngAfterViewInit() {
    const self = this;
    // this.player = audiojs(document.getElementById('audio'));
    // console.log(this.player);
    // this.player.muted(true);
  }
  // this.player.on('timeupd
  closeDialog() {
    this.stop();
    this.activeModal.dismiss();
  }

  playAudio() {
    this.player = document.getElementById('audio');
    this.player.play();
    this.playButtonDisplay = "none";
    this.pauseButtonDisplay = "initial";
  }

  pauseAudio() {
    this.player = document.getElementById('audio');
    this.player.pause();
    this.playButtonDisplay = "initial";
    this.pauseButtonDisplay = "none";
  }

  getDuration(player) {
    var seekable = player.seekable();
    return seekable && seekable.length ? seekable.end(0) - seekable.start(0) : 0;
  }

  onSeekPercentChange(player, seekPercent, duration) {
    var seekable = player.seekable();

    if (seekable && seekable.length) {
      // constrain currentTime
      player.currentTime(Math.max(0, Math.min(seekable.end(0), seekable.start(0) + (seekPercent * duration))));
    }
  }

  ngOnDestroy() {
    this.audioSubscriber.unsubscribe();
    this.stop();

  }
}
